import { render } from "./ResultModal.vue?vue&type=template&id=7140c00c&scoped=true"
import script from "./ResultModal.vue?vue&type=script&lang=js"
export * from "./ResultModal.vue?vue&type=script&lang=js"

import "./ResultModal.vue?vue&type=style&index=0&id=7140c00c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7140c00c"]])

export default __exports__